import React from 'react'
import { useAppSelector } from '../../../../store/hooks'
import { LinkButton } from '../../../../components/Button/LinkButton'
import { selectCrossClientRecentExecutions, selectCrossClientRecentExecutionsLoading } from '../../../../store/crossClient/crossClientLanding'
import classNames from 'classnames'

export const CrossClientHistory = () => {
  const recentExecutions = useAppSelector(selectCrossClientRecentExecutions)
  const recentExecutionsLoading = useAppSelector(selectCrossClientRecentExecutionsLoading)

  return (
    <div className='card shadow-sm border-0 h-100'>
      <div className='card-header bg-white border-0'>
        <h5 className='card-title mb-0'>
          <i className='bi bi-clock-history zocks-text-primary me-2'></i>Recent Queries
        </h5>
      </div>
      <div className='card-body'>
        {recentExecutionsLoading ? (
          <div className='d-flex justify-content-center p-4'>
            <div className='spinner-border zocks-text-primary' role='status'>
              <span className='visually-hidden'>Loading...</span>
            </div>
          </div>
        ) : !recentExecutions.length ? (
          <div className='text-center p-4 text-muted'>
            <i className='bi bi-search fs-3 mb-2 d-block'></i>
            <p>No recent queries found</p>
          </div>
        ) : (
          <ul className='list-group list-group-flush'>
            {recentExecutions.map((execution, index) => (
              <li
                key={execution.id}
                className={classNames('list-group-item d-flex justify-content-between align-items-center p-3 border-bottom', { 'border-top': index === 0 })}
              >
                <div className='d-flex flex-column'>
                  <span className='text-truncate' style={{ maxWidth: '450px' }}>
                    {execution.userQuestion}
                  </span>
                </div>
                <LinkButton variant='primary' to={`/cross-client/executions/${execution.id}`} className='ms-2'>
                  <i className='bi bi-arrow-right me-1'></i>
                  View Details
                </LinkButton>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  )
}
